import { DateTime } from 'luxon';

export const DATE_DISPLAY_FORMAT = 'dd/MM/yyyy';
export const TIME_DISPLAY_FORMAT = 'HH:mm';
export const MONTH_DISPLAY_FORMAT = 'MMMM yyyy';

export function formatDisplayDate(isoDate: string | null | undefined): string | null {
  if (!isoDate) {
    return null;
  }

  const parsed = DateTime.fromISO(isoDate);
  return parsed.isValid ? parsed.toFormat(DATE_DISPLAY_FORMAT) : isoDate;
}

export function formatDisplayTime(isoDateTime: string | null | undefined): string | null {
  if (!isoDateTime) {
    return null;
  }

  const parsed = DateTime.fromISO(isoDateTime, { setZone: true });
  return parsed.isValid ? parsed.toFormat(TIME_DISPLAY_FORMAT) : null;
}

export function parseDisplayDate(displayDate: string | null | undefined): DateTime | null {
  if (!displayDate) {
    return null;
  }

  const parsed = DateTime.fromFormat(displayDate, DATE_DISPLAY_FORMAT);
  return parsed.isValid ? parsed : null;
}

export function formatDisplayMonth(displayDate: string | null | undefined): string | null {
  const parsed = parseDisplayDate(displayDate);
  return parsed ? parsed.toFormat(MONTH_DISPLAY_FORMAT).toUpperCase() : null;
}
